import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'

import * as Firebase from 'firebase/app'

const firebaseConfig = {
  apiKey: 'AIzaSyCREKXs3brLcTBsPm4bJnUEQ2WHVD4THEA',
  authDomain: 'thatsa10-27c9e.firebaseapp.com',
  databaseURL: 'https://thatsa10-27c9e.firebaseio.com',
  projectId: 'thatsa10-27c9e',
  storageBucket: 'thatsa10-27c9e.appspot.com',
  messagingSenderId: '886707903481',
  appId: '1:886707903481:web:b9877d149432c4afadfb28',
  measurementId: 'G-EZBWSRZYXP'
}

function initFirebase () {
  Firebase.initializeApp(firebaseConfig)
  return new Promise((resolve, reject) => {
    Firebase.firestore().enablePersistence({ synchronizeTabs: true })
      .then(resolve)
      .catch(err => {
        if (err.code === 'failed-precondition') {
          reject(err)
          // Multiple tabs open, persistence can only be
          // enabled in one tab at a a time.
        } else if (err.code === 'unimplemented') {
          reject(err)
          // The current browser does not support all of
          // the features required to enable persistence
        }
      })
  })
}

var secondaryApp = Firebase.initializeApp(firebaseConfig, 'secondary')

export { Firebase, initFirebase, secondaryApp }
